import { render, staticRenderFns } from "./GaugeChart.vue?vue&type=template&id=4c236e9e&scoped=true&"
import script from "./GaugeChart.vue?vue&type=script&lang=js&"
export * from "./GaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c236e9e",
  null
  
)

export default component.exports